import { ThemeProvider, createTheme } from "@mui/material/styles";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useCallback } from "react";
import { grey } from "@mui/material/colors";

import {
  getLanguageDateLocale,
  getLanguageDatePicker,
} from "../helper/LanguageHelper";

const buildTheme = () =>
  createTheme({
    palette: {
      mode:
        localStorage.getItem("theme") === "theme-dark" ? "dark" : "light",
      ...(localStorage.getItem("theme") === "theme-light"
        ? {
            // palette values for light mode
            primary: { main: "#cc0000" },
            text: {
              secondary: "#fff",
              primary: grey[800],
            },
          }
        : {
            // palette values for dark mode
            primary: { main: "#cc0000" },
            text: {
              primary: "#fff",
              secondary: grey[500],
            },
          }),
    },
    components: {
      /*  MuiDialogTitle: {
                     defaultProps: {
                         title: 'Si'
                     }
                 }, */
      MuiOutlinedInput: {
        defaultProps: {
          className: "datepicker",
        },
        styleOverrides: {
          input: {
            borderWidth: "0px !important",
          },
          error: {
            borderWidth: "0px !important",
          },
          focused: {
            borderWidth: "0px !important",
          },
          notchedOutline: {
            borderWidth: "0px !important",
          },
        },
      },
    },
  });

export const CustomDateTimePicker = ({ date, minTime, onDatePickerChange }) => {
  useTranslation();

  const [darkTheme, setDarkTheme] = useState(() => buildTheme());

  const handleProjectChange = useCallback(() => {
    setDarkTheme(buildTheme());
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleProjectChange);
    document.addEventListener("touch", handleProjectChange);
    return () => {
      document.removeEventListener("click", handleProjectChange);
      document.removeEventListener("touch", handleProjectChange);
    };
  }, [handleProjectChange]);

  return (
    <ThemeProvider theme={darkTheme}>
      <LocalizationProvider
        localeText={getLanguageDatePicker()}
        adapterLocale={getLanguageDateLocale()}
        dateAdapter={AdapterMoment}
      >
        <Stack spacing={3}>
          <DateTimePicker
            value={date}
            onChange={(newDate) => {
              onDatePickerChange(newDate);
            }}
            minTime={minTime}
            minDate={moment(moment().add(15, "minutes"))}
          />
        </Stack>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default CustomDateTimePicker;
